import type { ReactNode } from "react"

interface PageHeaderProps {
  eyebrow?: string
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  trailing?: ReactNode
}

export function PageHeader({ eyebrow, title, subtitle, actions, trailing }: PageHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-6 mb-6 pt-1">
      <div className="min-w-0">
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight leading-none text-foreground flex items-center gap-3 flex-wrap">
          {title}
          {trailing}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-muted-foreground max-w-xl">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  )
}
